import { Configuration } from './configuration'; // Your generated config

const getApiBaseUrl = (): string => {
    // Use environment variable if available, fallback to localhost for development
    return process.env.REACT_APP_API_URL || 'http://localhost:8080';
};

export const apiConfiguration = new Configuration({
    basePath: getApiBaseUrl(),
});